import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { AgendaComponent } from '../agenda/agenda.component'
import { EventoProgramadoComponent } from '../evento-programado/evento-programado.component';
import { AgendaService } from '../../services/agenda/agenda.service';
import { CommonModule, formatDate } from '@angular/common';
@Component({
  standalone: true,
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  imports: [CalendarModule, FormsModule, AgendaComponent, EventoProgramadoComponent, CommonModule]
})
export class CalendarComponent {

  date: Date = new Date();
  eventos: any[] = [];
  pt: any;
  diaDeHoje: any;
  selectedDates: Date[] = [];

  constructor(private primengConfig: PrimeNGConfig, private agendaService: AgendaService) {
    this.pt = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
      dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
      dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
      monthNames: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
      monthNamesShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
      today: 'Hoje',
      clear: 'Limpar'
    };
  }

  ngOnInit() {  
    this.primengConfig.setTranslation(this.pt);
    this.carregarEventos();
  }

  carregarEventos() {
    const ano = this.date.getFullYear();
    const mes = this.date.getMonth(); 
    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);
  
    const datInicial = formatDate(primeiroDia, 'yyyy-MM-dd', 'en-US');
    const datFinal = formatDate(ultimoDia, 'yyyy-MM-dd', 'en-US');
  
    this.agendaService.getEventos(datInicial, datFinal).subscribe(response => {
      if (response.totalRegistros > 0 && response.formatoArquivos.length > 0) {
        this.eventos = response.formatoArquivos;
        this.selectedDates = this.eventos.map(evento => new Date(evento.datInicioEvento));
      } else {
        this.eventos = [];
        this.date = new Date();
      }      
    });
  }
  
  formatarData(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  hasEvent(date: Date): boolean {
    const dataFormatada = this.formatarData(date);
    return this.eventos.some(evento => evento.datInicioEvento === dataFormatada);
  }
}
